/**
 * Component to display children based on the condition provided.
 * Used for making code more like HTML
 * USAGE:
 * <IF condition={someCondition && someMoreCondition}>
 *  <ComponentToRender />
 * </IF>
 *
 * @param {Component} children => Component to be rendered if the condition is true
 * @param {boolean} condition => Condition to evaluate
 */

import { FC } from 'react';

type IfProps = {
  children: JSX.Element;
  condition: boolean;
};

export const IF: FC<IfProps> = ({ children, condition }) => {
  if (condition) {
    return children;
  }
  return null;
};
